import { observer } from 'mobx-react-lite'
import moment from 'moment'
import { FC, useCallback, useContext, useEffect, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useLocation } from 'react-router-dom'
import { Context } from '../../..'
import useWindowDimensions from '../../../core/hooks/useWindowDimensions'
import { LOCALES } from '../../../core/i18n/locales'
import { modifyName } from '../../../core/utils/studio_utils'
import { declOfNum, prevent } from '../../../core/utils/utils'
import XCalendar from '../XCalendar'
import { Slider } from 'antd'

import styles from './SearchLine.module.scss'

import Item from './Item'
import ItemDate from './ItemDate'
import { Loader } from '../../../components/Loader'

interface SearchLineProps {
	categories: any[]
	defaultCategory?: string
	services: any[]
	cities: any[]
	scrollXTop?: number
	onSearch: (
		city: string | null,
		category: string | null,
		service: string | null,
		date: string | null,
		time: string | null
	) => void
	onCitySelected: (city: string | null) => void
	onCatSelected?: (cat: string | null) => void
}

const SearchLine: FC<SearchLineProps> = ({
	categories,
	defaultCategory = '',
	services,
	cities,
	scrollXTop = 162,
	onSearch,
	onCitySelected,
	onCatSelected = () => {},
}) => {
	const { formatMessage: f } = useIntl()

	const { store, studioStore } = useContext(Context)

	const { width } = useWindowDimensions()
	const location = useLocation()

	const [city, setCity] = useState('')
	const [metro, setMetro] = useState('')
	// const [category, setCategory] = useState("")
	const [date, setDate] = useState('')
	const [time, setTime] = useState('')
	const [service, setService] = useState('')

	const [selectedDateStr, setSelectedDateStr] = useState('')
	const [selectedDate, setSelectedDate] = useState(moment())
	const [minDate, setMinDate] = useState(moment())
	const [maxDate, setMaxDate] = useState(moment().month(12))

	// const [searchPriceValue, setSearchPriceValue] = useState([0, 10000])
	// const [searchSquareValue, setSearchSquareValue] = useState([0, 1500])
	// const [searchRatingValue, setSearchRatingValue] = useState([0, 5])

	// const [priceWindow, studioStore.setPriceWindow] = useState(false)
	// const [squareWindow, studioStore.setSquareWindow] = useState(false)
	// const [ratingWindow, studioStore.setRatingWindow] = useState(false)

	const onMouseUp = (e: any) => {
		let date_window = document.getElementById('date_window')
		let price_window = document.getElementById('price_window')
		let square_window = document.getElementById('square_window')
		let rating_window = document.getElementById('rating_window')
		let time_window = document.getElementById('time_window')

		if (date_window != null && !date_window.contains(e.target) && studioStore.dateWindow) {
			studioStore.setDateWindow(false)
		}

		if (price_window != null && !price_window.contains(e.target) && studioStore.priceWindow) {
			studioStore.setPriceWindow(false)
		}

		if (square_window != null && !square_window.contains(e.target) && studioStore.squareWindow) {
			studioStore.setSquareWindow(false)
		}

		if (rating_window != null && !rating_window.contains(e.target) && studioStore.ratingWindow) {
			studioStore.setRatingWindow(false)
		}

		if (time_window != null && !time_window.contains(e.target) && studioStore.timeWindow) {
			studioStore.setTimeWindow(false)
		}
	}

	const getFilterCities = () => {
		return cities
			.filter((v) => {
				// v.name.toLowerCase().includes(city.toLowerCase())
				let slice = v.name.slice(0, city.length)
				return slice.toLowerCase() == city.toLowerCase()
			})
			.sort((a: any, b: any) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
	}

	const getMetros = () => {
		//
		return studioStore.metros.find((v) => v.name.toLowerCase() == city.toLowerCase())
	}

	useEffect(() => {
		if (studioStore.selectedCityName != '') {
			setCity(studioStore.selectedCityName)
		}
	}, [studioStore.selectedCityName])

	// useEffect(() => {
	//   if (studioStore.category != "") {
	//     setCategory(studioStore.category)
	//   }
	// }, [studioStore.category])

	useEffect(() => {
		if (studioStore.selectedCat != null) {
			studioStore.setCategory(studioStore.selectedCat.name)
		}

		let scrollXTopX = scrollXTop

		let search_linex = document.getElementById('search_linex')
		if (search_linex != null) {
			if (location.pathname == '/') {
				scrollXTopX = search_linex.offsetTop - 100
			} else {
				scrollXTopX = search_linex.offsetTop + 10
			}
		}

		const onScroll = (ev: any) => {
			const scrollTop = ev.target.scrollTop

			if (scrollTop > scrollXTopX && !studioStore.fixedLine) {
				studioStore.setFixedLine(true)
			} else if (scrollTop < scrollXTopX && studioStore.fixedLine) {
				studioStore.setFixedLine(false)
			}
		}

		document.addEventListener('mouseup', onMouseUp)
		document.getElementById('root')!.addEventListener('scroll', onScroll)

		return () => {
			document.removeEventListener('mouseup', onMouseUp)
			document.getElementById('root')!.removeEventListener('scroll', onScroll)
		}
	}, [onMouseUp])

	const onChangeCompletePrice = (value: number[]) => {
		// console.log(value)
		studioStore.setSearchPrice(value)
	}
	const onChangeCompleteSquare = (value: number[]) => {
		// console.log(value)
		studioStore.setSearchSquare(value)
	}
	const onChangeCompleteRating = (value: number[]) => {
		// console.log(value)
		studioStore.setSearchRating(value)
	}

	const getRatingValue = () => {
		const [min, max] = studioStore.searchRating

		return (
			<div className={styles.rating_margin}>
				<span className={styles.rating}>от {min}</span>
				<img key={'first_rating'} src='/assets/icons/default/rating-star.webp' />
				<span className={styles.rating} style={{ marginLeft: '10px' }}>
					до {max}
				</span>
				<img key={'second_rating'} src='/assets/icons/default/rating-star.webp' />
			</div>
		)
	}

	if (!studioStore || !studioStore.selCountry || !studioStore.selCountry.currency) {
		return <Loader />
	}

	return (
		<>
			<div className={styles.search_wrapper}>
				<div className={styles.item_container}>
					<Item
						type={'city'}
						value={city}
						onChange={(ev: any) => setCity(ev.target.value)}
						onClick={() => studioStore.setCityWindow(true)}
						onBlur={() =>
							width < 768
								? false
								: setTimeout(() => {
										studioStore.setCityWindow(false)
									}, 100)
						}
						onFocus={() => (width < 768 ? false : studioStore.setCityWindow(true))}
					/>
					<Item
						type={'cats'}
						value={studioStore.category == 'all' ? '' : modifyName(studioStore.category)}
						onChange={(ev) => studioStore.setCategory(ev.target.value)}
						onClick={() => studioStore.setCatWindow(true)}
						onBlur={() =>
							width < 768
								? false
								: setTimeout(() => {
										studioStore.setCatWindow(false)
									}, 300)
						}
						onFocus={() => (width < 768 ? false : studioStore.setCatWindow(true))}
					/>
					<Item
						type={'date'}
						value={date}
						onChange={() => {}}
						onClick={() => (width > 768 ? false : studioStore.setDateWindow(true))}
						onBlur={() => {}}
						onFocus={() => {}}
						dateOnClick={() => studioStore.setDateWindow(true)}
					/>

					<Item
						type={'price'}
						value={`от ${studioStore.searchPrice[0]} ${studioStore.selCountry.currency} до ${studioStore.searchPrice[1]} ${studioStore.selCountry.currency}`}
						onChange={() => {}}
						onClick={() => (width > 768 ? false : studioStore.setPriceWindow(true))}
						onBlur={() => {}}
						onFocus={() => {}}
						dateOnClick={() => studioStore.setPriceWindow(true)}
					/>
				</div>
				<div className={styles.item_container} style={{ marginTop: '10px' }}>
					<Item
						type={'metro'}
						value={studioStore.metro}
						onChange={(ev: any) => studioStore.setMetro(ev.target.value)}
						onClick={() => studioStore.setMetroWindow(true)}
						onBlur={() =>
							width < 768
								? false
								: setTimeout(() => {
										studioStore.setMetroWindow(false)
									}, 300)
						}
						onFocus={() => (width < 768 ? false : studioStore.setMetroWindow(true))}
						disabled={getMetros() == undefined}
					/>
					<Item
						type={'square'}
						value={`от ${studioStore.searchSquare[0]} м² до ${studioStore.searchSquare[1]} м²`}
						onChange={() => {}}
						onClick={() => (width > 768 ? false : studioStore.setSquareWindow(true))}
						onBlur={() => {}}
						onFocus={() => {}}
						dateOnClick={() => studioStore.setSquareWindow(true)}
					/>
					<Item
						type={'rating'}
						value={getRatingValue()}
						onChange={() => {}}
						onClick={() => (width > 768 ? false : studioStore.setRatingWindow(true))}
						onBlur={() => {}}
						onFocus={() => {}}
						dateOnClick={() => studioStore.setRatingWindow(true)}
					/>
					<Item
						type={'stocks'}
						value={studioStore.metro}
						onChange={(ev: any) => studioStore.setMetro(ev.target.value)}
						onClick={() => studioStore.setMetroWindow(true)}
						onBlur={() =>
							width < 768
								? false
								: setTimeout(() => {
										studioStore.setMetroWindow(false)
									}, 300)
						}
						onFocus={() => (width < 768 ? false : studioStore.setMetroWindow(true))}
					/>
					<div className={styles.search_button}>
						<button
							onClick={() =>
								onSearch(
									city,
									studioStore.category,
									service,
									selectedDateStr != '' ? selectedDate.format('D.MM.YYYY') : null,
									time
								)
							}
						>
							<FormattedMessage id='home_action' />
						</button>
					</div>
				</div>
				<div className={styles.search_line} id='search_linex'>
					{/* CITY */}
					<div className={styles.sl_window + ' ' + styles.top_level_1}>
						<div
							id='city_window'
							className={styles.sl_window_body + (studioStore.cityWindow ? ' ' + styles.openned : '')}
						>
							<div className={styles.slwb}>
								<div className={styles.slwb_close} onClick={() => studioStore.setCityWindow(false)}>
									<i className='far fa-xmark'></i>
								</div>

								{width > 768 ? (
									<></>
								) : (
									<>
										<div className={styles.mob_search}>
											<label htmlFor='mob_search_city'>
												<FormattedMessage id='studios_search' />
											</label>
											<input
												id='mob_search_city'
												type='text'
												placeholder={f({ id: 'studios_srch_all' })}
												value={city}
												onChange={(ev) => setCity(ev.target.value)}
											/>
										</div>
									</>
								)}

								{city != '' ? (
									<>
										<h4>
											{store.locale == 'ru-RU' ? 'Найдено' : 'Finded'} {getFilterCities().length}{' '}
											{declOfNum(
												getFilterCities().length,
												store.locale == 'ru-RU' ? ['город', 'города', 'городов'] : ['city', 'cities', 'cities']
											)}
										</h4>
										<div
											className={styles.options}
											style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.08)', paddingBottom: '10px' }}
										>
											{getFilterCities().map((item) => (
												<div
													className={styles.option + (city == item.name ? ' ' + styles.selected : '')}
													onClick={() => {
														setCity(store.locale == LOCALES.RUSSIAN ? item.name : item.name_en)
														studioStore.setMetro('')
														if (width < 768) {
															studioStore.setCityWindow(false)
														}
													}}
												>
													{store.locale == LOCALES.RUSSIAN ? item.name : item.name_en}
												</div>
											))}
										</div>
									</>
								) : (
									<></>
								)}

								<h4>
									<FormattedMessage id='studios_srch_selcity' />
								</h4>

								<div className={styles.options}>
									{
										<div
											className={styles.option + (city == '' ? ' ' + styles.selected : '')}
											onClick={() => {
												setCity('')
												studioStore.setMetro('')
												studioStore.setCityWindow(false)
												onCitySelected('')
											}}
										>
											<FormattedMessage id='studios_srch_not' />
										</div>
									}
									{cities.map((item) => (
										<div
											className={styles.option + (city == item.name ? ' ' + styles.selected : '')}
											onClick={() => {
												setCity(store.locale == LOCALES.RUSSIAN ? item.name : item.name_en)
												studioStore.setMetro('')
												onCitySelected(store.locale == LOCALES.RUSSIAN ? item.name : item.name_en)
												if (width < 768) {
													studioStore.setCityWindow(false)
												}
											}}
										>
											{store.locale == LOCALES.RUSSIAN ? item.name : item.name_en}
										</div>
									))}
								</div>
							</div>
						</div>
					</div>

					{/* CATEGORIES */}
					<div className={styles.sl_window + ' ' + styles.top_level_1}>
						<div
							id='cat_window'
							className={
								styles.sl_window_body + ' ' + styles.left_for_cats + (studioStore.catWindow ? ' ' + styles.openned : '')
							}
						>
							<div className={styles.slwb}>
								<div className={styles.slwb_close} onClick={() => studioStore.setCatWindow(false)}>
									<i className='far fa-xmark'></i>
								</div>

								{width > 768 ? (
									<></>
								) : (
									<>
										<div className={styles.mob_search}>
											<label htmlFor='mob_search_cat'>
												<FormattedMessage id='studios_search' />
											</label>
											<input
												id='mob_search_cat'
												type='text'
												placeholder={f({ id: 'studios_srch_all' })}
												value={studioStore.category == 'all' ? 'Все' : studioStore.category}
												onChange={(ev) => studioStore.setCategory(ev.target.value)}
											/>
										</div>
									</>
								)}

								<h4>
									<FormattedMessage id='studios_srch_selcat' />
								</h4>

								<div className={styles.options}>
									<div
										className={styles.option + (studioStore.category == '' ? ' ' + styles.selected : '')}
										onClick={() => {
											studioStore.setCategory('all')
											studioStore.setCategorySN('')
											onCatSelected('')
											if (width < 768) {
												studioStore.setCatWindow(false)
											}
										}}
									>
										<FormattedMessage id='studios_srch_not' />
									</div>
									{categories.map((item) => (
										<div
											className={
												styles.option +
												(studioStore.category == (store.locale == LOCALES.RUSSIAN ? item.name : item.name_en)
													? ' ' + styles.selected
													: '')
											}
											onClick={() => {
												studioStore.setCategory(store.locale == LOCALES.RUSSIAN ? item.name : item.name_en)
												studioStore.setCategorySN(item.subname)
												onCatSelected(item.subname)
												if (width < 768) {
													studioStore.setCatWindow(false)
												}
											}}
										>
											{store.locale == LOCALES.RUSSIAN ? modifyName(item.name) : item.name_en}
										</div>
									))}
								</div>
							</div>
						</div>
					</div>

					{/* DATE */}
					<div className={styles.sl_window + ' ' + styles.top_level_1}>
						<div
							id='date_window'
							className={
								styles.sl_window_body +
								' ' +
								styles.left_for_date +
								(studioStore.dateWindow ? ' ' + styles.openned : '')
							}
						>
							<div className={styles.slwb}>
								<div className={styles.slwb_close} onClick={() => studioStore.setDateWindow(false)}>
									<i className='far fa-xmark'></i>
								</div>

								<h4>
									<FormattedMessage id='studios_srch_seldate' />
								</h4>

								<XCalendar
									minDate={minDate}
									maxDate={maxDate}
									selectedDate={selectedDate}
									onSelectDate={(ev) => {
										setSelectedDateStr(ev.format('DD MMM YYYY'))
										setSelectedDate(ev)
										setDate(ev.format('DD MMM YYYY'))
										if (width < 768) {
											studioStore.setDateWindow(false)
										}
									}}
									studio={null}
									width='366px'
									monthView='tabs'
								/>

								<div className={styles.clear_date}>
									<button
										onClick={() => {
											setSelectedDateStr('')
											setDate('')
										}}
									>
										<FormattedMessage id='studios_srch_deldate' />
									</button>
								</div>
							</div>
						</div>
					</div>

					{/* PRICE */}
					<div className={styles.sl_window + ' ' + styles.top_level_1}>
						<div
							id='price_window'
							className={
								styles.sl_window_body +
								' ' +
								styles.left_for_price +
								(studioStore.priceWindow ? ' ' + styles.openned_low_hight : '')
							}
						>
							<div className={styles.slwb_price_square}>
								<div className={styles.slwb_close} onClick={() => studioStore.setPriceWindow(false)}>
									<i className='far fa-xmark'></i>
								</div>

								{width > 768 ? (
									<></>
								) : (
									<>
										<div className={styles.mob_search}>
											<label htmlFor='mob_search_cat'>
												<FormattedMessage id='studios_search' />
											</label>
											<input
												id='mob_search_cat'
												type='text'
												placeholder={f({ id: 'studios_srch_all' })}
												value={studioStore.category == 'all' ? 'Все' : studioStore.category}
												onChange={(ev) => studioStore.setCategory(ev.target.value)}
											/>
										</div>
									</>
								)}

								<h4>
									<FormattedMessage id='studios_srch_selprice' />
								</h4>

								<div className={styles.search_price}>
									<div className={styles.price_container}>
										<span className={styles.price}>{studioStore.searchPrice[0]}</span>
										<div className={styles.slider}>
											<Slider
												min={0}
												max={10000}
												range
												value={studioStore.searchPrice}
												onChange={(val: number[]) => studioStore.setSearchPrice(val)}
												onChangeComplete={onChangeCompletePrice}
												styles={{
													track: {
														background: 'transparent',
													},
													tracks: {
														background: `#F7CE30`,
													},
												}}
											/>
										</div>
										<span className={styles.price}>{studioStore.searchPrice[1]}</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					{/* METRO */}
					<div className={styles.sl_window + ' ' + styles.top_level_2} onClick={(ev) => prevent(ev)}>
						<div
							id='metro_window'
							className={styles.sl_window_body + (studioStore.metroWindow ? ' ' + styles.openned : '')}
						>
							<div className={styles.slwb}>
								<div className={styles.slwb_close} onClick={() => studioStore.setMetroWindow(false)}>
									<i className='far fa-xmark'></i>
								</div>

								{width > 768 ? (
									<></>
								) : (
									<>
										<div className={styles.mob_search}>
											<label htmlFor='mob_search_cat'>
												<FormattedMessage id='studios_search' />
											</label>
											<input
												id='mob_search_cat'
												type='text'
												placeholder={f({ id: 'studios_srch_all' })}
												value={studioStore.metro}
												onChange={(ev) => studioStore.setMetro(ev.target.value)}
											/>
										</div>
									</>
								)}

								<h4>
									<FormattedMessage id='studios_srch_selmetro' />
								</h4>

								<div className={styles.options}>
									<div
										className={styles.option + (studioStore.metro == '' ? ' ' + styles.selected : '')}
										onClick={() => {
											studioStore.setMetro('')
											if (width < 768) {
												studioStore.setMetroWindow(false)
											}
										}}
									>
										<FormattedMessage id='studios_srch_not' />
									</div>
									{getMetros() != undefined &&
										getMetros().items.map((item: any) => (
											<div
												className={styles.option + (studioStore.metro == item.name ? ' ' + styles.selected : '')}
												onClick={(ev) => {
													prevent(ev)

													studioStore.setMetro(item.name)
													if (width < 768) {
														studioStore.setMetroWindow(false)
													}
												}}
											>
												{item.name}
											</div>
										))}
								</div>
							</div>
						</div>
					</div>

					{/* SQUARE */}
					<div className={styles.sl_window + ' ' + styles.top_level_2}>
						<div
							id='square_window'
							className={
								styles.sl_window_body +
								' ' +
								styles.left_for_square +
								(studioStore.squareWindow ? ' ' + styles.openned_low_hight : '')
							}
						>
							<div className={styles.slwb}>
								<div className={styles.slwb_close} onClick={() => studioStore.setSquareWindow(false)}>
									<i className='far fa-xmark'></i>
								</div>

								{/* {width > 768 ? (
									<></>
								) : (
									<>
										<div className={styles.mob_search}>
											<label htmlFor='mob_search_cat'>
												<FormattedMessage id='studios_search' />
											</label>
											<input
												id='mob_search_cat'
												type='text'
												placeholder={f({ id: 'studios_srch_all' })}
												value={studioStore.category == 'all' ? 'Все' : studioStore.category}
												onChange={(ev) => studioStore.setCategory(ev.target.value)}
											/>
										</div>
									</>
								)} */}

								<h4>
									<FormattedMessage id='studios_srch_selsquare' />
								</h4>

								<div className={styles.search_price}>
									<div className={styles.price_container}>
										<span className={styles.price_square}>{studioStore.searchSquare[0]}</span>
										<div className={styles.slider}>
											<Slider
												min={0}
												max={1500}
												range
												value={studioStore.searchSquare}
												onChange={(val: number[]) => studioStore.setSearchSquare(val)}
												onChangeComplete={onChangeCompleteSquare}
												styles={{
													track: {
														background: 'transparent',
													},
													tracks: {
														background: `#F7CE30`,
													},
												}}
											/>
										</div>
										<span className={styles.price_square}>{studioStore.searchSquare[1]}</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					{/* RATING */}
					<div className={styles.sl_window + ' ' + styles.top_level_2}>
						<div
							id='rating_window'
							className={
								styles.sl_window_body +
								' ' +
								styles.left_for_rating +
								(studioStore.ratingWindow ? ' ' + styles.openned_low_hight : '')
							}
						>
							<div className={styles.slwb}>
								<div className={styles.slwb_close} onClick={() => studioStore.setRatingWindow(false)}>
									<i className='far fa-xmark'></i>
								</div>

								{/* {width > 768 ? (
									<></>
								) : (
									<>
										<div className={styles.mob_search}>
											<label htmlFor='mob_search_cat'>
												<FormattedMessage id='studios_search' />
											</label>
											<input
												id='mob_search_cat'
												type='text'
												placeholder={f({ id: 'studios_srch_all' })}
												value={studioStore.category == 'all' ? 'Все' : studioStore.category}
												onChange={(ev) => studioStore.setCategory(ev.target.value)}
											/>
										</div>
									</>
								)} */}

								<h4>
									<FormattedMessage id='studios_srch_selrating' />
								</h4>

								<div className={styles.search_price}>
									<div className={styles.price_container}>
										<span>{studioStore.searchRating[0]}</span>
										<div className={styles.slider}>
											<Slider
												min={0}
												max={5}
												range
												value={studioStore.searchRating}
												onChange={(val: number[]) => studioStore.setSearchRating(val)}
												onChangeComplete={onChangeCompleteRating}
												styles={{
													track: {
														background: 'transparent',
													},
													tracks: {
														background: `#F7CE30`,
													},
												}}
											/>
										</div>
										<span>{studioStore.searchRating[1]}</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					{/* SERVICE */}
					<div className={styles.sl_window}>
						<div
							id='serv_window'
							className={styles.sl_window_body + ' ' + styles.b5 + (studioStore.servWindow ? ' ' + styles.openned : '')}
						>
							<div className={styles.slwb}>
								<h4>Выберите услугу</h4>

								<div className={styles.options}>
									<div
										className={styles.option + (service == '' ? ' ' + styles.selected : '')}
										onClick={() => {
											setService('')
										}}
									>
										<FormattedMessage id='studios_srch_not' />
									</div>
									{services.map((item) => (
										<div
											className={styles.option + (service == item.name ? ' ' + styles.selected : '')}
											onClick={() => {
												setService(item.name)
											}}
										>
											{item.name}
										</div>
									))}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

{
	/* <div className={styles.sl_body}>
						<div
							className={styles.search_line__item}
							onClick={() => (width > 768 ? false : studioStore.setCityWindow(true))}
						>
							<label htmlFor='sl_city'>
								<FormattedMessage id='studios_srch_city' />
							</label>
							{width > 768 ? (
								<input
									id='sl_city'
									name='sl_city'
									type='text'
									placeholder={f({ id: 'studios_srch_all' })}
									value={city}
									onChange={(ev) => setCity(ev.target.value)}
									onBlur={() =>
										width < 768
											? false
											: setTimeout(() => {
													studioStore.setCityWindow(false)
												}, 100)
									}
									onFocus={() => (width < 768 ? false : studioStore.setCityWindow(true))}
								/>
							) : (
								<span style={{ color: city == '' ? 'rgba(0, 0, 0, 0.3)' : '#000' }}>
									{city == '' ? f({ id: 'studios_srch_all' }) : city}
								</span>
							)}
						</div>
						{getMetros() != undefined && getMetros().items.length > 0 ? (
							<div
								className={styles.search_line__item}
								onClick={() => (width > 768 ? false : studioStore.setMetroWindow(true))}
							>
								<label htmlFor='sl_metro'>
									<FormattedMessage id='studios_srch_metro' />
								</label>
								{width > 768 ? (
									<input
										id='sl_metro'
										name='sl_metro'
										type='text'
										placeholder={f({ id: 'studios_srch_all' })}
										value={studioStore.metro}
										onChange={(ev) => studioStore.setMetro(ev.target.value)}
										onBlur={() =>
											width < 768
												? false
												: setTimeout(() => {
														studioStore.setMetroWindow(false)
													}, 300)
										}
										onFocus={() => (width < 768 ? false : studioStore.setMetroWindow(true))}
									/>
								) : (
									<span style={{ color: studioStore.metro == '' ? 'rgba(0, 0, 0, 0.3)' : '#000' }}>
										{studioStore.metro == '' ? f({ id: 'studios_srch_all' }) : studioStore.metro}
									</span>
								)}
							</div>
						) : (
							<></>
						)}
						<div
							className={styles.search_line__item}
							onClick={() => (width > 768 ? false : studioStore.setCatWindow(true))}
						>
							<label htmlFor='sl_cat'>
								<FormattedMessage id='studios_srch_cats' />
							</label>
							{width > 768 ? (
								<input
									id='sl_cat'
									name='sl_cat'
									type='text'
									placeholder={f({ id: 'studios_srch_all' })}
									value={studioStore.category == 'all' ? '' : modifyName(studioStore.category)}
									onChange={(ev) => studioStore.setCategory(ev.target.value)}
									onBlur={() =>
										width < 768
											? false
											: setTimeout(() => {
													studioStore.setCatWindow(false)
												}, 300)
									}
									onFocus={() => (width < 768 ? false : studioStore.setCatWindow(true))}
								/>
							) : (
								<span style={{ color: studioStore.category == '' ? 'rgba(0, 0, 0, 0.3)' : '#000' }}>
									{studioStore.category == '' || studioStore.category == 'all'
										? f({ id: 'studios_srch_all' })
										: modifyName(studioStore.category)}
								</span>
							)}
						</div>
						<div
							className={styles.search_line__item}
							onClick={() => (width > 768 ? false : studioStore.setDateWindow(true))}
						>
							<label htmlFor='sl_date'>
								<FormattedMessage id='studios_srch_date' />
							</label>
							{width > 768 ? (
								<input
									id='sl_date'
									name='sl_date'
									type='text'
									placeholder='__ /__ /____'
									value={date}
									onClick={() => studioStore.setDateWindow(true)}
								/>
							) : (
								<span style={{ color: date == '' ? 'rgba(0, 0, 0, 0.3)' : '#000' }}>
									{date == '' ? '__ /__ /____' : date}
								</span>
							)}
						</div>
						<div className={styles.search_line__item + ' ' + styles.last}>
							<button
								onClick={() =>
									onSearch(
										city,
										studioStore.category,
										service,
										selectedDateStr != '' ? selectedDate.format('D.MM.YYYY') : null,
										time
									)
								}
							>
								<FormattedMessage id='studios_srch_action' />
							</button>
						</div>
					</div> */
}

export default observer(SearchLine)
